module.exports = __webpack_public_path__ + "img/cutout.de95b924.png";